/* CAVIERA JEWELS — 2026 theme behaviours */
(function () {
  'use strict';

  var header = document.querySelector('[data-site-header]');
  var overlay = document.querySelector('[data-menu-overlay]');
  var hero = document.querySelector('[data-hero]');

  /* Header: solid state once past the hero, hide on scroll down */
  var lastY = window.scrollY;
  function onScroll() {
    var y = window.scrollY;
    if (header) {
      var threshold = hero ? hero.offsetHeight - 90 : 40;
      header.classList.toggle('is-solid', y > threshold);
      if (y > 300 && y > lastY + 4) header.classList.add('is-hidden');
      else if (y < lastY - 4 || y < 300) header.classList.remove('is-hidden');
    }
    lastY = y;
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* Menu overlay */
  function setMenu(open) {
    if (!overlay) return;
    overlay.classList.toggle('is-open', open);
    document.documentElement.style.overflow = open ? 'hidden' : '';
    document.querySelectorAll('[data-menu-open]').forEach(function (b) {
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
  document.querySelectorAll('[data-menu-open]').forEach(function (b) {
    b.addEventListener('click', function () { setMenu(true); });
  });
  document.querySelectorAll('[data-menu-close]').forEach(function (b) {
    b.addEventListener('click', function () { setMenu(false); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setMenu(false);
  });

  /* Reveal on scroll */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
  }

  /* Current year */
  document.querySelectorAll('[data-year]').forEach(function (el) {
    el.textContent = String(new Date().getFullYear());
  });
})();
